if (!customElements.get('sticky-product-cart')) {
  customElements.define(
    'sticky-product-cart',
    class StickyProductCart extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.primaryButton = this.productInfo.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
        this.button = this.querySelector('button');
        if (!this.primaryButton || !this.button) return;

        this.productForm = this.primaryButton.closest('product-form');
        this.onClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.onClick);

        // Mirror the existing form so variant changes and cart requests have one source of truth.
        this.stateObserver = new MutationObserver(() => this.syncState());
        this.stateObserver.observe(this.primaryButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });
        this.syncState();

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        this.visibilityObserver.observe(this.primaryButton);

        // Keep errors from a sticky submission visible in the original form.
        this.errorObserver = new MutationObserver(() => {
          if (!this.submittedFromSticky) return;
          const error = this.productForm.querySelector(
            '.product-form__error-message-wrapper:not([hidden]), .product-form__recipient-error-message-wrapper:not([hidden])'
          );
          if (!error) return;
          this.submittedFromSticky = false;
          this.productForm.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
        this.errorObserver.observe(this.productForm, { attributes: true, childList: true, subtree: true });
      }

      syncState() {
        const loading = this.primaryButton.classList.contains('loading');
        this.button.disabled = this.primaryButton.disabled;
        this.button.setAttribute('aria-disabled', String(this.primaryButton.disabled || loading ||
          this.primaryButton.getAttribute('aria-disabled') === 'true'));
        this.button.setAttribute('aria-busy', String(loading));
        this.button.classList.toggle('loading', loading);
        this.button.querySelector('.loading__spinner').classList.toggle('hidden', !loading);
        const label = this.primaryButton.querySelector('span').textContent.trim();
        this.button.querySelector('.sticky-product-cart__button-label').textContent = label;
        this.button.setAttribute('aria-label', label);
        if (this.primaryButton.hasAttribute('aria-haspopup')) {
          this.button.setAttribute('aria-haspopup', this.primaryButton.getAttribute('aria-haspopup'));
        }
      }

      handleClick() {
        this.syncState();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        this.submittedFromSticky = true;
        // A real click preserves the existing form's quantity, properties, validation and cart drawer.
        this.primaryButton.click();
        this.syncState();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.stateObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.errorObserver?.disconnect();
      }
    }
  );
}
